import { ZoomInOutlined } from '@ant-design/icons';
import EmptyData from 'components/common/EmptyData';
import useHelper from 'hook/useHelper';
import useReport from 'hook/useReport';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import iconDownload from '../../../../assets/images/StockAnalysis/icon-download.svg';

import './Report.scss';

export default function Report() {
  const [Path, setPath] = useState('')
  const ReportStore = useSelector((state) => state?.ReportStore);
  const StocksAnalysisStore = useSelector((state) => state?.StocksAnalysisStore);
  const { downloadFileFromUrl } = useHelper();

  useEffect(() => {
    setPath('')
  }, [StocksAnalysisStore?.inputSearch])

  useEffect(() => {
    setTimeout(() => {
      setPath(ReportStore?.reportAnalysis?.path)
    }, 300)
  }, [ReportStore?.reportAnalysis?.path])

  const handleOpenPdf = (link) => {
    window.open(`${link}#toolbar=0&embedded=true&view=FitH`, '_blank')
  }

  return (
    Path ? <>
      <div className='dtxgcadwyz' onClick={() => handleOpenPdf(Path)}><ZoomInOutlined /></div>
      <iframe src={`${Path}#toolbar=0&embedded=true&view=FitH`}
        className="hreedrmmzm"
        style={{ display: 'block', width: '100%', height: '100%' }}>
      </iframe>
    </> : <div className='hhkxqbergc'>
      <EmptyData />
    </div>
  )
}